import DiTokenManager from '../../auth/DiTokenManager';

var AuthenticationUtil = {
    signOut: function() {
        DiTokenManager.removeToken();
        this.signOutFromModern();
    },

    signOutFromModern: function() {
        location.href = '/modern/auth/logout';
    }
};

export default AuthenticationUtil;
